import script from "./BodyForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./BodyForm.vue?vue&type=script&lang=ts&setup=true"

import "./BodyForm.vue?vue&type=style&index=0&id=749cfd1f&lang=css"

const __exports__ = script;

export default __exports__